import { render, staticRenderFns } from "./CoursesManagement.vue?vue&type=template&id=a17d9ac2"
import script from "./CoursesManagement.vue?vue&type=script&lang=ts"
export * from "./CoursesManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports